package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.components.yaform.YaFormScope
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLDialogElement

enum class ModalSize(val klass: String) {
    SM(klass = "modal-sm"),
    MD(klass = "modal-md"),
    LG(klass = "modal-lg"),
    XL(klass = "modal-xlg"),
    FULLSCREEN(klass = "modal-fs"),
}

@Composable
fun Modal(
    onHide: () -> Unit,
    size: ModalSize = ModalSize.MD,
    allowOutsideDismissal: Boolean = true,
    content: @Composable () -> Unit,
) {
    var ref: HTMLDialogElement? = null

    Dialog({
        classes(size.klass)
        style {
            overflow("auto")
        }
        attr("open", "")
        onClick { event ->
            if (allowOutsideDismissal && event.target === ref) {
                onHide()
            }
        }
        ref {
            ref = it
            onDispose { ref = null }
        }
    }) {
        Article {
            content()
        }
    }
}

@Composable
fun ModalCloseBtn(onHide: () -> Unit) {
    Button({
        attr("rel", "prev")
        onClick { onHide() }
    }) {  }
}

@Composable
fun <T : Any> YaFormScope<T>.ModalFooterButtons(
    onHide: () -> Unit,
    cancelLabel: String = "Abbrechen",
    submitLabel: String = "Speichern",
    resetLabel: String? = null,
) {
    Footer({ classes("flex-row") }) {
        if (resetLabel != null) {
            YaFormButton(ButtonType.Reset, {
                classes("ghost", "text-is-invalid")
            }) { Text(resetLabel) }
        }
        Div({ classes("flex-grow") })
        YaFormButton(ButtonType.Button, {
            classes("ghost")
            onClick { onHide() }
        }) { Text(cancelLabel) }
        YaFormButton(ButtonType.Submit, {
            classes("primary")
        }) { Text(submitLabel) }
    }
}
